import styled from 'styled-components';

export const MediaPage = styled.div`
    // .detailed__info {
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: center;
    //     align-items: flex-end;
    //     padding: 0.5rem;
    //     @media ${(props) => props.theme.breakpoints.lg_tablet} {
    //         flex-direction: row;
    //     }

    //     img {
    //         max-width: 270px;
    //         height: 270px;
    //         margin: 0 auto;
    //         object-fit: cover;
    //         box-shadow: 0 4px 60px rgba(0, 0, 0, 0.6);
    //         @media ${(props) => props.theme.breakpoints.lg_tablet} {
    //             width: auto;
    //             height: 20vw;
    //             margin: 0 1rem 0 0;
    //         }
    //     }

    //     &__text {
    //         flex: 1;
    //         margin: 1rem auto 0 auto;
    //         text-align: center;
    //         @media ${(props) => props.theme.breakpoints.lg_tablet} {
    //             text-align: left;
    //         }

    //         strong {
    //             text-transform: uppercase;
    //             font-size: 0.8rem;
    //         }

    //         h4 {
    //             font-size: 1.5rem;
    //             text-transform: capitalize;
    //             font-family: 'Montserrat', sans-serif;
    //             @media ${(props) => props.theme.breakpoints.lg_tablet} {
    //                 font-size: 3rem;
    //             }
    //         }
    //     }
    // }

    .detailed__songs {
        padding: 1rem;
    }
`;
